<p-card class="dashBoard">
  <div style="position:relative">
    @if (ps.hasAnyRole(['ROLE_HIDE_MODEL_MARKET_CENTER']) || !ps.hasAnyRole(['ROLE_MODEL_SEC_MANAGER'])) {
<div style="
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      opacity: 0.5;
      background-color: white;
      height: 100%;">
      </div>
    }
    <div class="title" (click)="showModelMarketCenter()">Model Market Center</div>
    <br class="clear"/>
    @if (!data) {
      <div class='loading-spinner'></div>
    }
    @if (data) {
      <div>
        <mat-tab-group style="clear: both;" animationDuration="0ms" dynamicHeight [(selectedIndex)]="selectedIndex" (selectedTabChange)="selectedTabChange()">
          <mat-tab>
            <ng-template mat-tab-label>Summary</ng-template>
            <ng-template matTabContent>
              <div class="bordered-block">
                <div class="auto-reb-panel-header border-bottom"><b>Status</b></div>
                @if (data?.modelsWithUnreadChanges) {
                  <div class="auto-reb-panel-button" (click)="showModelsWithUnreadChanges()">
                    <table>
                      <tr>
                        <td class="column-icon"><span class="warning-icon"></span></td>
                        <td class="column-count"><span>{{data.modelsWithUnreadChanges}}</span></td>
                        <td class="column-label"><span>Models with new changes</span></td>
                        <td class="column-chevron irb-blue">Review <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></td>
                      </tr>
                    </table>
                  </div>
                }
                @if (data?.modelsPendingReview) {
                  <div class="auto-reb-panel-button" (click)="showModelsPausedForReview()">
                    <table>
                      <tr>
                        <td class="column-icon"><span class="pause-icon-grey"></span></td>
                        <td class="column-count"><span>{{data.modelsPendingReview || 0}}</span></td>
                        <td class="column-label"><span>Models with automated rebalancing paused for review</span></td>
                        <td class="column-chevron irb-blue">Review <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></td>
                      </tr>
                    </table>
                  </div>
                }
                @if ((!data?.modelsWithUnreadChanges && data?.modelsPendingReview) || (data?.modelsWithUnreadChanges && !data?.modelsPendingReview)) {
                  <div class="auto-reb-panel-button cursor-default">
                    <table>
                      <tr>
                        <td colspan="4" class="column-label"><span>&nbsp;</span></td>
                      </tr>
                    </table>
                  </div>
                }
                @if ((!data?.modelsPendingReview && !data?.modelsWithUnreadChanges)) {
                  <div class="auto-reb-panel-button cursor-default"
                    style="line-height: 50px; text-align: center;">
                    <table>
                      <tr>
                        <td colspan="4" class="column-label"><span>No new changes to subscribed Model Market Center models</span></td>
                      </tr>
                    </table>
                  </div>
                }
              </div>
              <div class="bordered-block">
                <div class="auto-reb-panel-header border-bottom"><b>Summary</b></div>
                <div class="summary-box flex" style="margin-left:16px;">
                  <div (click)="showSubscribedModels()" class="summary-panel-block">
                    <div class="count">{{data.subscribedModels}}</div>
                    <div>Subscribed Models</div>
                  </div>
                  <div (click)="showAssignedPortfolios()" class="summary-panel-block">
                    <div class="count">{{data.assignedPortfolios || 0 | number}}</div>
                    <div>Assigned Portfolios</div>
                  </div>
                  <div class="summary-panel-block cursor-default" style="margin-right:16px;">
                    <div class="count">${{aumFormatted}}</div>
                    <div>AUM</div>
                  </div>
                </div>
              </div>
            </ng-template>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>Billing</ng-template>
            <ng-template matTabContent>
              <div class="block">
                <div class="auto-reb-panel-header"><b>Monthly Billing Summary</b></div>
                <div class="summary-box flex">
                  <div class="billing-panel-block">
                    <div style="padding-bottom: 2px;">Most Recent</div>
                    @for (item of mmcMonthlyBillingSummaryRecent; track item; let i = $index) {
                      <div class="download-item">
                        <a (click)="viewMMCMonthlyBillingSummary(item.value)">{{item.name}}</a>&nbsp;
                        <img src="../../assets/images/download.svg" (click)="viewMMCMonthlyBillingSummary(item.value)" class="cursor-pointer"/>
                        @if (i === 0 && showBell) {
                          <fa-icon [icon]="faBell"
                          style="margin-left: 3px; color: #ff8800;"></fa-icon>
                        }
                      </div>
                    }
                  </div>
                  <div class="billing-panel-block">
                    <div style="padding-bottom: 2px;">Previous Months</div>
                    <irb-dropdown-filter #IrbDropdownPreviousMonths (search)="getPreviousMonths($event)" size="15"
                      hoverPanelWidth="150"
                      [value]="selectedMnthYr"
                    (selection)="onSelectMonthYear($event)"></irb-dropdown-filter>
                    <div class="download-item" [class.disabled]="selectedMnthYrValue === -1"><a (click)="selectedMnthYrValue !== -1 && viewMMCMonthlyBillingSummary(selectedMnthYrValue)">
                    Download&nbsp;</a>
                    <img src="../../assets/images/download.svg"
                      (click)="selectedMnthYrValue !== -1 && viewMMCMonthlyBillingSummary(selectedMnthYrValue)"/>
                  </div>
                </div>
              </div>
            </div>
            <div style="height:60px;"></div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  }
  <div class="widget-footer">
    <div class="timestamp">{{timestamp}}</div>
    <a class="" (click)="refreshWidgetData()">
      <div class="refreshIcon"></div>
      Refresh
    </a>
  </div>
</div>
</p-card>
